import { Link } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Breadcrumb from "@/components/layout/Breadcrumb";
import CompareCard from "@/components/feature/CompareCard";
import { compareList } from "@/mocks/compare";
import { useSeo } from "@/hooks/useSeo";

const method = [
  { t: "选定同台对象", d: "从易混淆概念或同类公关打法里挑一对比较" },
  { t: "逐行拉平对比", d: "把特征、风险、话术拆成可对照的维度" },
  { t: "给出独立小结", d: "不站队，只把差别与判断逻辑说清楚" },
];

export default function Duibi() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "全网热瓜对比分析手册",
      description: "把半开麦与真开麦、诚恳道歉与公关甩锅等易混淆概念摆上台面逐行对比。",
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: "https://w01xfj.cn/" },
        { "@type": "ListItem", position: 2, name: "对比分析", item: "https://w01xfj.cn/duibi" },
      ],
    },
  ];

  useSeo({
    title: "全网热瓜对比分析手册｜真假开麦·道歉诚意·公关打法对照",
    description:
      "全网热瓜对比分析：半开麦与真开麦界定、诚恳道歉与公关甩锅声明、流量艺人塌房剧本、官方通报与粉丝澄清的信源博弈，逐行对比帮你辨清差别、避免被带节奏。",
    canonical: "https://w01xfj.cn/duibi",
    jsonLd,
  });

  return (
    <>
      <Navbar />
      <main>
        <div className="mx-auto max-w-container px-4 pt-10 md:px-6">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "对比分析" }]} />
        </div>

        <section className="mx-auto max-w-container px-4 pt-6 md:px-6">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-end">
            <div className="max-w-2xl lg:col-span-8">
              <span className="text-xs font-semibold uppercase tracking-widest text-secondary-700">对比分析</span>
              <h1 className="mt-2 text-3xl text-foreground-950 md:text-4xl">把相似概念，摆在同一台天平上</h1>
              <p className="mt-3 text-sm leading-7 text-foreground-600">
                真开麦和垫音差在哪？诚恳道歉与公关稿怎么一眼看穿？流量明星塌房和实力派为什么是两种剧本？
                我们把这些容易混淆的问题做成同台对比手册，横向拉平、逐行对照，避免在热搜里被单方带节奏。
              </p>
            </div>
            <div className="rounded-2xl bg-secondary-100/70 p-5 lg:col-span-4">
              <h2 className="text-sm font-semibold text-foreground-900">一本对比手册怎么做出来的</h2>
              <ol className="mt-3 space-y-2.5">
                {method.map((m, i) => (
                  <li key={m.t} className="flex items-start gap-3 text-sm text-foreground-700">
                    <span className="font-display flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-500 text-xs text-background-50">
                      {i + 1}
                    </span>
                    <span>
                      <strong className="font-medium text-foreground-900">{m.t}</strong> · {m.d}
                    </span>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-container px-4 py-10 md:px-6">
          <div className="space-y-6">
            {compareList.map((c) => (
              <CompareCard key={c.id} topic={c} priority />
            ))}
          </div>
        </section>

        <section className="mx-auto max-w-container px-4 pb-4 md:px-6">
          <div className="flex flex-col gap-4 rounded-3xl bg-primary-600 p-6 text-background-50 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h2 className="text-lg font-semibold">对比之外，还想看完整过程？</h2>
              <p className="mt-1 text-sm text-background-100/90">系列事件时间线负责“纵向还原过程”，对比分析负责“横向厘清差别”，配合使用吃瓜更透。</p>
            </div>
            <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
              <Link to="/#series" className="inline-flex h-11 items-center justify-center whitespace-nowrap rounded-full bg-background-50 px-5 text-sm font-medium text-primary-700 transition hover:bg-background-100">
                去追系列时间线
              </Link>
              <Link to="/pandian" className="inline-flex h-11 items-center justify-center whitespace-nowrap rounded-full border border-background-50/50 px-5 text-sm text-background-50 transition hover:bg-background-50/10">
                看同类盘点
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}